<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="isAddPopup ? '태스크 추가' : '태스크 수정'" width="600px" @close="close()">
    <div slot="content">
      <el-form :model="formData" :rules="rules" ref="taskForm">
        <el-row>
          <el-form-item prop="grpId" label="태스크 그룹">
            <el-select v-model="formData.grpId" style="width: 100%" :disabled="formData.editableFlag === 'N'">
              <el-option v-for="grp in grpList" :key="grp.grpId" :label="grp.grpName" :value="grp.grpId"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item prop="taskId" label="태스크 아이디">
              <el-input v-model="formData.taskId" placeholder="입력해주세요." :disabled="formData.editableFlag === 'N'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="taskName" label="태스크명">
              <el-input v-model="formData.taskName" placeholder="입력해주세요." :disabled="formData.editableFlag === 'N'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item prop="action" label="태스크 구분">
              <el-select v-model="formData.action" style="width: 100%" :disabled="formData.editableFlag === 'N' || !isAddPopup">
                <el-option v-for="action in taskActions" :key="action.variableId" :label="action.variableId" :value="action.variableId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="timeout" label="타임아웃(초)">
              <el-input-number style="width:100%" v-model="formData.timeout" controls-position="right" :min="1" :disabled="formData.editableFlag === 'N'"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item prop="orderbyIndex" label="정렬 순서">
              <el-input-number style="width:100%" v-model="formData.orderbyIndex" controls-position="right" :min="0" :disabled="formData.editableFlag === 'N'"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="실패 판단 방법">
              <el-select v-model="formData.failoverJudgeType" style="width: 100%" :disabled="formData.editableFlag === 'N'" @change="onSelectChange">
                <el-option v-for="type in ['STATUS', 'MESSAGE', 'SKIP']" :key="type" :label="type" :value="type"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="formData.failoverJudgeType === 'MESSAGE'">
          <el-form-item  prop="failoverJudgeText" label="실패 판단 문자열">
            <el-input v-model="formData.failoverJudgeText" placeholder="입력해주세요." :disabled="formData.editableFlag === 'N'"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item>
            <div>
              <span class="title-popup-s mr-r4">하위 태스크 설정</span>
              <el-switch v-model="childTaskFlag" active-value="Y" inactive-value="N" :disabled="formData.editableFlag === 'N'" @change="onSwitchChange"></el-switch>
            </div>
            <el-select v-model="formData.childTaskId" style="width: 100%" :disabled="childTaskFlag === 'N' || formData.editableFlag === 'N'">
              <el-option v-for="task in taskList" :key="task.taskId" :label="`${task.taskId} (${task.taskName})`" :value="task.taskId"></el-option>
            </el-select>
            <!-- <el-input v-model="formData.childTaskId" :disabled="childTaskFlag === 'N' || formData.editableFlag === 'N'" placeholder="입력해주세요."></el-input> -->
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" v-if="formData.editableFlag === 'Y'">
      <el-button size="large" type="solid" @click="onSaveButtonClick">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, isEqual, cloneDeep, filter, remove, sortBy } from 'lodash';
import msgUtil from '@/utils/message';
import amsSettingsApi from '@/api/settings/server/ams-settings';

export default {
  name: 'WTaskSettingPopup',
  props: {
    selectedGroup: {
      type: Object,
      default: null,
    },
    selectedTask: {
      type: Object,
    },
    varDefGrpList: {
      type: Array,
    },
  },
  data() {
    return {
      childTaskFlag: 'N',
      formData: {
        grpId: '',
        taskId: '',
        taskName: '',
        action: '',
        failoverJudgeType: '',
        failoverJudgeText: '',
        editableFlag: 'Y',
        childTaskId: '',
        timeout: null,
        orderbyIndex: null,
      },
      rules: {
        grpId: [
          { required: true, validator: this.validateFieldInfo, trigger: 'blur' },
        ],
        action: [
          { required: true, validator: this.validateFieldInfo, trigger: 'blur' },
        ],
        taskId: [
          { required: true, validator: this.validateTask, trigger: 'blur' },
        ],
        taskName: [
          { required: true, validator: this.validateTask, trigger: 'blur' },
        ],
        timeout: [
          { required: true, validator: this.validateFieldInfo, trigger: 'blur' },
        ],
        failoverJudgeText: [
          { required: true, validator: this.validateFailover, trigger: 'blur' },
        ],
        orderbyIndex: [
          { required: true, validator: this.validateFieldInfo, trigger: 'blur' },
        ],
      },
      taskList: [],
      grpList: [],
    };
  },
  computed: {
    isAddPopup() {
      return isNil(this.selectedTask);
    },
    taskActions() {
      const actionList = sortBy(filter(this.varDefGrpList, (e) => e.grpId === 'ACTION' && e.variableId !== 'PROC'), ['orderbyIndex']);
      return actionList;
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadGroupData();
      if (!this.isAddPopup) {
        const childTaskId = this.selectedTask.childTaskId;
        this.childTaskFlag = !isNil(childTaskId) && childTaskId !== '' ? 'Y' : 'N';
        if (this.childTaskFlag === 'Y') {
          this.onSwitchChange(this.childTaskFlag);
        }
        this.formData = cloneDeep(this.selectedTask);
      } else {
        this.formData.timeout = 300;
        this.formData.orderbyIndex = 0;
        this.formData.action = this.taskActions[0].variableId;
        this.formData.failoverJudgeType = 'STATUS';
      }
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.$refs.taskForm.resetFields();
      this.taskList = [];
      this.childTaskFlag = 'N';
      this.formData = {
        grpId: '',
        taskId: '',
        taskName: '',
        action: '',
        failoverJudgeType: '',
        failoverJudgeText: '',
        editableFlag: 'Y',
        childTaskId: '',
        timeout: null,
        orderbyIndex: null,
      };
    },
    loadGroupData() {
      amsSettingsApi.getAmsGrpList({ grpType: 'TASK' }).then((response) => {
        if (response.data.success) {
          this.grpList = response.data.data;
          if (this.isAddPopup && isNil(this.selectedGroup)) {
            this.formData.grpId = this.grpList.length > 0 ? this.grpList[0].grpId : '';
          } else if (!isNil(this.selectedGroup)) {
            this.formData.grpId = this.selectedGroup.grpId;
          }
        }
      });
    },
    /**
     * taskId, taskName 유효성 검사 (중복체크)
     * @author jeee12
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateTask(rule, value, callback) {
      const fieldName = rule.field;
      if (isNil(value) || value === '') {
        return callback(new Error('필수 정보입니다.'));
      }
      const isModified = this.isAddPopup || !isEqual(value, this.selectedTask[fieldName]);
      amsSettingsApi.checkTaskValidation({ [fieldName]: value }).then((response) => {
        const isUniq = response.data.data;
        if (isModified && !isUniq && fieldName === 'taskId') {
          callback(new Error('이미 사용 중인 태스크 아이디입니다.'));
        } else if (isModified && !isUniq && fieldName === 'taskName') {
          callback(new Error('이미 사용 중인 태스크 이름입니다.'));
        }
        callback();
      });
      return true;
    },
    /**
     * 태스크 그룹, 태스크 구분, 타임아웃, 정렬 순서에 대한 유효성검사
     * @author yelim
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateFieldInfo(rule, value, callback) {
      const fieldName = rule.field;
      if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다.'));
      } else if (fieldName === 'timeout' && value < 0) {
        callback(new Error('1이상의 값을 설정해주세요.'));
      } else {
        callback();
      }
    },
    validateFailover(rule, value, callback) {
      const failoverType = this.formData.failoverJudgeType;
      if (failoverType === 'MESSAGE' && (isNil(value) || value === '')) {
        callback(new Error('필수 정보입니다.'));
      } else {
        callback();
      }
    },
    /**
     * 저장 버튼 click
     * @author jeee12
     */
    onSaveButtonClick() {
      this.$refs.taskForm.validate().then((valid) => {
        if (valid) {
          const params = { ams2xTask: this.formData };
          if (!this.isAddPopup) {
            params.originalTaskId = this.selectedTask.taskId;
          }
          amsSettingsApi.insertTask(params).then((response) => {
            const target = '태스크';
            const action = this.isAddPopup ? msgUtil.action.ADD : msgUtil.action.MODIFY;
            if (response.data.success) {
              this.close();
              this.$emit('re-load');
            }
            this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
          });
        }
      }).catch(() => {});
    },
    onSelectChange(value) {
      if (value !== 'MESSAGE') {
        this.$refs.taskForm.clearValidate('failoverJudgeText');
        this.formData.failoverJudgeText = '';
      }
    },
    /**
     * switch change
     * @author jeee12
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onSwitchChange(value) {
      if (value === 'Y') {
        amsSettingsApi.getTaskList({}).then((response) => {
          if (response.data.success) {
            this.taskList = response.data.data;
            if (!this.isAddPopup) {
              // 선택한 task는 제거
              remove(this.taskList, (e) => e.taskId === this.selectedTask.taskId);
            }
          }
        });
      } else {
        this.formData.childTaskId = '';
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TaskSetting/popup/TaskSettingPopup.vue